<template>
  <el-dialog
    title="Relieve PO Lines"
    :visible.sync="visible"
    size="small"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <div>
      <el-row type="flex" align="middle" justify="start">
        {{ reliefStatus === 'Over' ? 'The following PO lines are overrelieved. ' : reliefStatus === 'Under' ? 'The following PO lines are underrelieved. ' : ''}}For each line, please choose
        whether you wish to close it out or leave it as is.
      </el-row>
      <el-row type="flex" align="middle" justify="center">
        <el-table
          id="close-po-line-table"
          style="margin-top: 12px"
          :data="poLines"
          border
          ref="closePoLineTable">
          <el-table-column prop="number" label="Line#" width="75">
            <template slot-scope="scope">
              <el-row type="flex" justify="start">
                {{ scope.row.line_number }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="PO Remaining" width="120">
            <template slot-scope="scope">
              <el-row type="flex" justify="end">
                {{ parseFloat((actualPoLines.find((line) => parseInt(line.id) == parseInt(scope.row.form.relieves.value)) || {}).remaining_decimal || 0).toFixed(2) }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="Description" fit>
            <template slot-scope="scope">
              <el-row type="flex" justify="start">
                {{ scope.row.form.description }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="amount_decimal" label="AP Amount" width="110">
            <template slot-scope="scope">
              <el-row type="flex" justify="end">
                {{ parseFloat(scope.row.form ? scope.row.form.amount_decimal : scope.row.amount_decimal).toFixed(2) }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="Close PO Line?" align="center" width="135">
            <template slot-scope="scope">
              <el-row type="flex" align="middle" justify="center">
                <el-checkbox v-model="poLineActions[scope.row.line_number || scope.row.form.line_number]"></el-checkbox>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
    <el-row type="flex" justify="end" align="middle" style="padding: 20px 0 0 0;">
      <el-button @click="$emit('closePoNotifModalVisible', false)">
        Cancel
      </el-button>
      <el-button type="primary" @click="submitSelection">
        Continue
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      reliefStatus: {
        type: String,
        required: false,
        default: () => ''
      },
      visible: Boolean,
      poLines: {
        type: Array,
        required: false,
        default: () => []
      },
      actualPoLines: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data () {
      return {
        poLineActions: []
      }
    },
    methods: {
      submitSelection () {
        this.$emit('closePoLines', this.poLineActions)
      },
      mapPoLinesToActions () {
        // Using the line.id instead of the line number for better consistency.
        this.poLines.forEach(line => {
          const lineNum = line.line_number || line.form.line_number || null
          if (lineNum) this.poLineActions[lineNum] = this.checkIfLineIsAlreadySelected(line) || false
        })
      },
      checkIfLineIsAlreadySelected (line) {
        if (line && line.form && line.form.id) {
          const apLine = this.$store.getters.getApLineById(line.form.id)
          return Object.keys(apLine).length ? (apLine.relieves_force_close || false) : false
        } else if (line && line.form && !line.form.id) {
          return line.form.relieves_force_close || false
        }
        return false
      }
    },
    watch: {
      visible () {
        if (this.visible) this.mapPoLinesToActions()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RouteComponents/Aps/ClosePoNotifModal.vue